import type { ReactNode } from 'react'
import './componentes.css'

export function Cartao({
  titulo,
  rotulo,
  acoes,
  children,
}: {
  titulo?: string

  /**
   * Nome acessível da `section`. Sem ele a `section` não é um landmark
   * navegável — e, quando a mesma tela tem dois cartões com campos de mesmo
   * rótulo, não há como se referir a um deles sem contar posição.
   */
  rotulo?: string
  acoes?: ReactNode
  children: ReactNode
}) {
  return (
    <section className="cartao" aria-label={rotulo}>
      {(titulo || acoes) && (
        <header className="cartao__topo">
          {/* h2 e não div: o catálogo e as telas dependem de hierarquia
              real para a navegação por cabeçalho do leitor de tela (A11Y-04). */}
          {titulo && <h2 className="cartao__titulo">{titulo}</h2>}
          {acoes && <div className="cartao__acoes">{acoes}</div>}
        </header>
      )}
      <div className="cartao__corpo">{children}</div>
    </section>
  )
}
